import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import RequireSuperAdmin from '@/components/Guard/RequireSuperAdmin'
import { RouteObject } from 'react-router-dom'
import RegulationsList from './components/Regulations'
import TechnicalTemplatesList from './components/TechnicalTemplates'
import ProductServiceManagement from './components/ProductServiceManagement'
import {
    SLATemplatesList,
    SLATemplatePage,
} from '@/modules/Service/components/SLA'
import AuthorizationRoutes from '@/modules/Authorization'
import { DataAccessList, CreateEditDataAccess } from './components/DataAccess'

const SettingsModule: RouteObject = {
    path: 'settings',
    children: [
        {
            path: 'service-templates',
            element: <TechnicalTemplatesList />,
        },
        {
            path: 'regulations',
            element: <RegulationsList />,
        },
        {
            path: 'sla-templates',
            element: <SLATemplatesList />,
        },
        {
            path: 'sla-templates/create',
            element: <SLATemplatePage />,
        },
        {
            path: 'sla-templates/:id/edit',
            element: <SLATemplatePage />,
        },
        {
            path: 'product-services',
            element: <ProductServiceManagement />,
        },
        // Authorization management (resources, scopes, permissions, policies)
        AuthorizationRoutes,
        // Data Access Assignments — super_admin only
        {
            path: 'data-access',
            element: (
                <RequireSuperAdmin>
                    <DataAccessList />
                </RequireSuperAdmin>
            ),
        },
        {
            path: 'data-access/new',
            element: (
                <RequireSuperAdmin>
                    <CreateEditDataAccess />
                </RequireSuperAdmin>
            ),
        },
        {
            path: 'data-access/:id/edit',
            element: (
                <RequireSuperAdmin>
                    <CreateEditDataAccess />
                </RequireSuperAdmin>
            ),
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export default SettingsModule
